import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const UploadFilm = () => {
  const [title, setTitle] = useState('');
  const [youtubeLink, setYoutubeLink] = useState(''); // New field for YouTube link
  const [genre, setGenre] = useState('');
  const [length, setLength] = useState('');
  const [visibility, setVisibility] = useState('private'); // Default to private
  const [feedbackCategories, setFeedbackCategories] = useState([]); // Multi-select for feedback categories
  const [notes, setNotes] = useState(''); 
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false); // State for modal visibility
  const navigate = useNavigate();

  const handleUpload = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token'); // JWT token for authentication

      const payload = {
        title,
        youtube_link: youtubeLink,
        length,
        genre,
        feedback_categories: feedbackCategories,
        visibility,
        notes,
      };

      console.log('Payload being sent to backend:', payload);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || 'https://api.eatourshorts.com'}/upload-film`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('Film uploaded successfully:', response.data);
      setSuccess('Film uploaded successfully!');
      setError(''); //Reset all the below fields after successful upload
      setTitle('');
      setYoutubeLink('');
      setGenre('');
      setLength('');
      setVisibility('private'); 
      setFeedbackCategories([]);
      setNotes('');


      // Show the modal after a successful upload
      setIsModalVisible(true);
    } catch (err) {
      console.error('Error uploading film:', err);
      setError(err.response?.data?.error || 'Failed to upload film.');
      setSuccess('');
    }
  };


  const handleCategoryChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setFeedbackCategories((prev) => [...prev, value]);
    } else {
      setFeedbackCategories((prev) => prev.filter((category) => category !== value));
    }
  };

  const closeModal = () => {
    setIsModalVisible(false); // Hide the modal
    navigate('/dashboard'); // Redirect to the dashboard after closing the modal
  };

  useEffect(() => {
    // Scroll to the top of the page when the component loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
    style={{
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      color: '#333',
      backgroundColor: '#ffe6e6', // Pale red background
      minHeight: '100vh', // Ensures the background covers the full viewport height
    }}
  >
      <h1 style={{ color: '#007bff', marginBottom: '20px', textAlign: 'center', }}>Upload a New Film</h1>
      {error && <p style={{ color: 'red', marginBottom: '20px' }}>{error}</p>}
      {success && <p style={{ color: 'green', marginBottom: '20px' }}>{success}</p>}
      <form
        onSubmit={handleUpload}
        style={{
          border: '1px solid #ccc',
          borderRadius: '10px',
          fontSize: '24px', // Change font size for labels
          overflow: 'hidden',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div style={{ backgroundColor: '#e3f2fd', padding: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Title:</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            maxLength="100" // Limit to 100 characters
            style={{
              width: '98%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              fontSize: '20px', // Font size for the input text
            }}
          />
        </div>
        <div style={{ backgroundColor: '#bbdefb', padding: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>YouTube Link:</label>
          <input
            type="url"
            value={youtubeLink}
            onChange={(e) => setYoutubeLink(e.target.value)} // Update the YouTube link state
            placeholder="https://www.youtube.com/watch?v=example"
            required
            maxLength="100"
            style={{
              width: '98%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              fontSize: '20px',
            }}
          />
        </div>
        <div style={{ backgroundColor: '#e3f2fd', padding: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Genre:</label>
          <input
            type="text"
            value={genre}
            onChange={(e) => setGenre(e.target.value)}
            required
            maxLength="100" // Limit to 100 characters
            style={{
              width: '98%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              fontSize: '20px', // Font size for the input text
            }}
          />
        </div>
        <div style={{ backgroundColor: '#bbdefb', padding: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Length (minutes):</label>
          <input
            type="number"
            value={length}
            onChange={(e) => setLength(e.target.value)}
            required
            maxLength="100" // Limit to 100 characters
            style={{
              width: '98%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              fontSize: '20px', // Font size for the input text
            }}
          />
        </div>
        <div style={{ backgroundColor: '#e3f2fd', padding: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Visibility:</label>
          <select
            value={visibility}
            onChange={(e) => setVisibility(e.target.value)}
            required
            style={{
              width: '98%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
            }}
          >
            <option value="private">Private</option>
            <option value="public">Public</option>
          </select>
        </div>
        <div style={{ backgroundColor: '#bbdefb', padding: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Feedback Categories:</label>
          <div>
            {['Writing', 'Cinematography', 'Editing', 'Art-Design', 'Costuming', 'Sound-Design', 'Directing'].map(
              (category) => (
                <label key={category} style={{ marginRight: '40px', display: 'inline-block' }}>
                  <input
                    type="checkbox"
                    value={category}
                    checked={feedbackCategories.includes(category)}
                    onChange={handleCategoryChange}
                    style={{ marginRight: '10px' }}
                  />
                  {category}
                </label>
              )
            )}
          </div>
        </div>
        <div style={{ backgroundColor: '#e3f2fd', padding: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Notes (Optional, max 100 words):</label>
          <textarea
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            rows="4"
            cols="50"
            placeholder="Add any notes for reviewers (optional)..."
            style={{
              width: '98%',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '5px',
              fontSize: '20px', // Font size for the input text
            }}
          />
        </div>
        <div style={{ backgroundColor: '#bbdefb', padding: '15px', textAlign: 'center' }}>
          <button
            type="submit"
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              fontSize: '48px',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#007bff')}
          >
            Upload Film
          </button>
        </div>
      </form>
      <button
        onClick={() => navigate('/dashboard')}
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          backgroundColor: '#6c757d',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          fontSize: '36px',
          cursor: 'pointer',
          transition: 'background-color 0.2s',
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = '#5a6268')}
        onMouseLeave={(e) => (e.target.style.backgroundColor = '#6c757d')}
      >
        Back to Dashboard
      </button>
  
      {/* Modal */}
      {isModalVisible && (
        <div
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'white',
            padding: '20px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            zIndex: 1000,
            textAlign: 'center',
          }}
        >
          <h2>Your masterpiece has been added!</h2>
          <button
            onClick={closeModal}
            style={{
              marginTop: '20px',
              padding: '10px 20px',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              fontSize: '36px',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
            }}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#218838')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#28a745')}
          >
            Close
          </button>
        </div>
      )}
      {/* Modal Overlay */}
      {isModalVisible && (
        <div
          onClick={closeModal}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '98%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 999,
          }}
        ></div>
      )}
    </div>
  );
};

export default UploadFilm;